import { addIcons } from 'ionicons'
import { closeOutline, searchOutline } from 'ionicons/icons'

export function registerGlobalIcons() {
  addIcons({
    'search-outline': searchOutline,
    'close-outline': closeOutline,
    'arrow-left-rounded': 'assets/icons/svg/arrow-left-rounded.svg',
    'calendar-flat': 'assets/icons/svg/calendar-flat.svg',
    'chevron--right': 'assets/icons/svg/chevron--right.svg',
    'funnel-rounded': 'assets/icons/svg/funnel-rounded.svg',
    'i-text': 'assets/icons/svg/i-text.svg',
    list: 'assets/icons/svg/list.svg',
    loop: 'assets/icons/svg/loop.svg',
    onboarding: 'assets/icons/svg/onboarding.svg',
    podium: 'assets/icons/svg/podium.svg',
    vs: 'assets/icons/svg/vs.svg',
    'warning-rounded': 'assets/icons/svg/warning-rounded.svg'
  })
}
